/**
 * Mapping from the complexity band to the progress bar's fill (MUS-401,
 * MUS-460).
 */

/**
 * Chevron activation threshold (CAT) — the value `position` reaches when the
 * chevron gate opens. Mirrors `DEFAULT_CHEVRON_ACTIVATION_THRESHOLD` in
 * `ChevronManager.ts`; kept as its own constant rather than imported so this
 * module, which is display-only, has no dependency on the Phaser/Gameplay
 * layer. Revisit if CAT becomes configurable per tier (MUS-443).
 */
export const CHEVRON_ACTIVATION_THRESHOLD = 0.8;

/**
 * Progress toward chevron activation, from the band the phrase now playing was
 * planned with, clamped to [0, 1].
 *
 * Anchored to `position` (MUS-460), the value the chevron gate itself checks,
 * so a full bar and chevron activation land on the same instant. The interim
 * MUS-401 mapping read `crMax` against 0.9 (the band's ceiling at activation
 * under the shipping CVR) instead — a full bar there landed slightly ahead of
 * the actual activation moment.
 */
export function fillFractionFromBand(band: { position: number } | null): number {
  if (band == null) return 0;
  const fraction = band.position / CHEVRON_ACTIVATION_THRESHOLD;
  return Math.min(Math.max(fraction, 0), 1);
}
